"use strict";
;

// Handles tasks related to the direct invite questionnaire
(function() {
    var PromoPopup = (function () {
        class PromoPopup {
            constructor(sampleKitId) {
                this.sampleKitId = sampleKitId;
            }

            show() {
                var div = this.setupOverlay();
                this.getSamplekitPromoInfoAsync(this.sampleKitId)
                    .then(result => this.setupPromoDisplay(div, result));
            }

            setupPromoDisplay(div, data) {
                var html = '<a class="close-reveal-modal">&#215;</a>'
                
                    + '<div class="text-center">' + data.popupMessage + '</div>';

                if ( (data.popupButtonText || '').length > 0 ) {
                    html += '<div class="text-center">'
                        + '<a href="' + data.popupUrl + '" class="button" target="_blank" data-sampleKitId="' + this.sampleKitId + '" data-track-category="My Products" data-track-action="' + data.popupButtonText + '" data-track-label="' + data.popupUrl + '">' + data.popupButtonText + '</a>'
                        + '</div>';
                }
                div.innerHTML = html;
            }

            setupOverlay() {
                var div = document.createElement('div');
                div.tabindex = -1;
                div.id = 'samplekit-popup-' + this.sampleKitId;
                div.className = 'reveal-modal fade tiny sample__popup in';
                div.style = 'visibility: visible; top:100px;;display: none;';
                div.index = 0;
                div.innerHTML = '<a class="close-reveal-modal">&#215;</a><h1 class="text-center"><i class="fa fa-2x fa-spin fa-spinner"></i></h1>';
                document.body.appendChild(div);
                window.showOverlay('samplekit-popup-' + this.sampleKitId);
                div.addEventListener('click', e => {
                    if ( e.target.classList.contains('close-reveal-modal')) {
                        var overlay = document.querySelector('.reveal-modal-bg');
                        overlay.parentNode.removeChild(overlay);
                        div.parentNode.removeChild(div);
                    }
                });
                return div;
            }

            getSamplekitPromoInfoAsync(sampleKitId) {
                return new Promise(function(resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                          resolve(JSON.parse(xhr.responseText));
                        } else {
                          reject(xhr.response);
                        }
                      };
                    xhr.onerror = () => reject(xhr.response);
                    xhr.open('GET', '/public/samples/' + sampleKitId + '/promo', true);
                    xhr.send();
                });
            }
        }

        
        return PromoPopup;
    })();

    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = PromoPopup;
    } else {
        window.PromoPopup = PromoPopup;
    }
})();